import { Form, FormInstance, Input, Select } from "antd";
import SelectDropdownLgIcon from "../../../assets/icons/SelectDropdownLgIcon";
import { selectSearchOption } from "../../../utils/utils";

type Props = {
  form: FormInstance<any>;
};

export default function IdentityOrganization({ form }: Props) {
  return (
    <div>
      <Form.Item
        name="business_role_id3"
        label="Identity Type"
        className="mb-1"
        rules={[
          {
            required: true,
            message: "Please select identity type",
          },
        ]}
      >
        <Select
          placeholder="Select"
          size="large"
          allowClear
          showSearch
          filterOption={selectSearchOption}
          options={[
            {
              label: "Passport",
              value: "Passport",
            },
          ]}
          suffixIcon={<SelectDropdownLgIcon />}
        />
      </Form.Item>
      <div className="text-body-text text-sm font-normal mb-4">
        NID, Birth Certificate or Passport
      </div>

      <Form.Item
        name="Passport Number"
        label="Passport Number"
        className="mb-4"
        rules={[
          {
            required: true,
            message: "Please enter passport number",
          },
        ]}
      >
        <Input size="large" placeholder="Enter passport number" />
      </Form.Item>
      <Form.Item
        name="Trade License"
        label="Trade License"
        className="mb-4"
        rules={[
          {
            required: true,
            message: "Please enter Trade License",
          },
        ]}
      >
        <Input size="large" placeholder="Trade license number" />
      </Form.Item>
      <Form.Item
        name="Tax Certificate"
        label="Tax Certificate"
        className="mb-1"
        rules={[
          {
            required: true,
            message: "Please enter Tax Certificate",
          },
        ]}
      >
        <Input size="large" placeholder="Tax certificate number" />
      </Form.Item>
    </div>
  );
}
